import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";

import Loading from './helper/Loading';
import { getWorkshopDataForView } from "./helper/APIcalls";
import PageHeader from "./helper/PageHeader";
import { Grid } from "@mui/material";


// fix for invisible links
const anchorColor = {
    color: "#0d6efd"
}
// an attempt at cleaing up workshop.js by splitting off the view workshop from view + edit workshop
// if used in a place thats not a route change props.match.params.id to props.id and pass in an id. Also need to pass in classes as a prop
const WorkshopView = props => {
    //const { classes } = props // classes is undefined

    const [classInfo, setClassInfo] = useState({})
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const mounted = useRef(true)

    const history = useHistory()

    async function fetchClassInfo() {
        const info = await getWorkshopDataForView(props.match.params.id)

        if (mounted.current) {
            // if the workshop does not exist, display workshop does not exist
            if (info === null) {
                setError(true)
                return
            }
            setClassInfo(info)
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchClassInfo()

        // on unmount
        return () => {
            mounted.current = false
        }
    })

    console.log(!loading && classInfo)

    return (
        <>
            <PageHeader
                title={"Class Information"}
                cancel={history.goBack}
            />
            {error ? <h1>Workshop not found</h1> :
                loading ?
                    <Loading /> :
                    <Grid container spacing={0}>

                        {/* <div className={classes}> */}
                            {/* <div className={classes.root}> */}
                            <Grid item xs={12} md={8}>
                                <dl className="workshop-details">

                                    <dt>Language:</dt>
                                    <dd>{classInfo.lang}</dd>

                                    <dt>{"Dates & Times:"}</dt>
                                    <dd>
                                        {classInfo.dates.map(d =>
                                            <div key={d.ID}>
                                                {moment(d.fromDate).format('LLL') + ' - ' + moment(d.toDate).format('LT')}
                                            </div>
                                        )}
                                    </dd>

                                    <dt>Training Provider: </dt>
                                    <dd>{classInfo.trainingProviderName} </dd>

                                    <dt> Created By: </dt>
                                    <dd>{classInfo.byUser} </dd>

                                    <dt> Last Modified By: </dt>
                                    <dd>{classInfo.lastModifiedByUserName} </dd>

                                    <dt>Location:</dt>

                                    {!classInfo.isRemote &&
                                    <dd>
                                        <div>{classInfo.location && classInfo.location.NAME}</div>
                                        <div>{classInfo.location && classInfo.location.STREET}</div>
                                        <div>{classInfo.location && classInfo.location.CITY + ', ' + classInfo.location.STATECODE + classInfo.location.ZIPCODE}</div>

                                        {classInfo.mapURL &&
                                            <a href={classInfo.mapURL} > Map URL for this training location</a>
                                        }
                                    </dd>
                                    }
                                    {classInfo.isRemote &&
                                    <dd>
                                        <p>Live Online Session</p>
                                        <p>{classInfo.remotePlatform}</p>
                                    </dd>
                                    }
                                    
                                    <dt>Cost:</dt>
                                    <dd>{"$" + classInfo.cost} (includes test)</dd>

                                    <dt>Registration Closing Date:</dt>
                                    <dd>{moment(classInfo.regCloseDate).format('LL, dddd')}</dd>
                                    
                                    <dt>Open to Public or Private:</dt>
                                    <dd>{classInfo.isPublic ? 'Public' : 'Private'}</dd>
                                   
                                    <dt>Contact Name:</dt>
                                    <dd>{classInfo.contact ? classInfo.contact.FIRSTNAME + ' ' + classInfo.contact.LASTNAME : "Invalid contact"}</dd>

                                    <dt>Contact Phone:</dt>
                                    <dd>{classInfo.contact ? classInfo.contact.PHONE : "Invalid contact"}</dd>

                                    <dt>Contact Email:</dt>
                                    <dd>{classInfo.contact ? classInfo.contact.EMAIL : "Invalid contact"}</dd>
                                   

                                    <dt>Event Day Details:</dt>
                                    <dd>
                                        {classInfo.notes}
                                        {classInfo.regExtUrl && <a style={anchorColor} href={classInfo.regExtUrl} > more information...</a>}

                                    </dd>

                                    <dt>Lead Instructor:</dt>
                                    <dd>{classInfo.leadInstructor || "No lead instructor"}</dd>

                                    <dt>Organization:</dt>
                                    <dd>
                                        {classInfo.organization || "No organization"}
                                    </dd>

                                    <dt>Class ID:</dt>
                                    <dd>{classInfo.workshopID}</dd>

                                    <dt>Module Presenters:</dt>
                                    <dd style={{ width: 'fit-content' }}>
                                        <dl>
                                            {classInfo.modulePresenters.map(mp =>
                                                mp.instructorName &&
                                                <div key={'mp' + mp.moduleId}>
                                                    <dt>{`${mp.moduleName}: `}</dt>
                                                    <dd>{mp.instructorName}</dd>
                                                </div>
                                            )}
                                        </dl>
                                    </dd>
                                </dl>

                                <dt>Training Program:</dt>
                                <dd>{classInfo.program}</dd>

                                <dt>Class Description:</dt>
                                <dd>{classInfo.description}</dd>

                                <dt>Max Participants:</dt>
                                <dd>{classInfo.maxParticipants}</dd>

                            </Grid>

                            {classInfo.waiver && 
                            <Grid item xs={12} md={4}>
                                <h1>Waiver Approved</h1>
                                <dl className="workshop-details">
                                    <dt>Requested By:</dt>
                                    <dd>{classInfo.waiver.requestedBy}</dd>

                                    <dt>Requested Date:</dt>
                                    <dd>{moment(classInfo.waiver.requestedDate).format('LLL')}</dd>

                                    <dt>Approved By:</dt>
                                    <dd>{classInfo.waiver.approvedBy}</dd>

                                    <dt>Approved Date:</dt>
                                    <dd>{classInfo.waiver.approvedDate && moment(classInfo.waiver.approvedDate).format('LLL')}</dd>

                                </dl>
                            </Grid>}
                        {/* </div> */}
                    </Grid>
            }
        </>
    );

}

export default WorkshopView